<template>
  <div id="webSite">
    <div v-if="detailShow">
      <ul>
        <li
          class="noticeList"
          v-for="(item ,index) in noticelist"
          :key="index"
          @click="goNoticeDetail(index)"
        >
          <div class="noticeCon">{{ item.content }}</div>
          <p>{{item.create_time}}</p>
        </li>
      </ul>
      <!-- 分页结构 -->
      <div class="fenye" v-if="per_page > pageNum">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="per_page"
          :page-size="3"
          @current-change="currentChange"
          :current-page="histNum2"
          style="padding-top: .8rem;padding-bottom: .8rem;border-radius: .875rem"
        ></el-pagination>
        <input
          placeholder="页数"
          v-model="histNum"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        />
        <span @click="currentChange(histNum)">GO</span>
      </div>
    </div>
    <!-- 公告详情页面 -->
    <div class="noticeDetail" v-else>
      <p class="timeShow">{{detailTime}}</p>
      <div class="detailCon">
        <p v-html="detailCon"></p>
        <img src="../base/img/icon_message_back.png" alt @click="goBack" />
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/tool/bus";
export default {
  props: ["currentIndex", "fromWhere", "con", "time"],
  data() {
    return {
      pageNum: 3,
      // 初始化显示第几页
      page: 1,
      per_page: 0,
      isLoading: true,
      histNum: "",
      histNum2: "",
      last_page: "",
      // 总条数
      total: 0,
      // 显示隐藏公告详情
      detailShow: true,
      // 公告详情内容
      detailCon: "",
      // 公告详情时间
      detailTime: "",
      // 公告列表
      noticelist: []
    };
  },
  mounted() {
    // 判断是从聊天页面的公告跳转 显示公告详情
    if (this.fromWhere == "chatSite") {
      this.detailShow = !this.detailShow;
      this.detailCon = this.con;
      this.detailTime = this.time;
      // console.log('this.detailCon',this.con,'this.detailTime',this.time,'currentIndex',this.currentIndex);
    }
    this.getChatNotice(this.page);
  },
  created() {},
  methods: {
    // 获取公告详情
    async goNoticeDetail(i) {
      this.detailShow = !this.detailShow;

      const { data } = await this.axios.post(
        this.chatUrl + "api/article/getArticleDetail",
        { article_id: this.noticelist[i].id }
      );
      console.log(data,11111111111);
      
      if (data.code == 0) {
        // this.noticelist=data.data
        this.detailCon = data.data.content;
        this.detailTime = data.data.create_time;
      }
    },
    // 返回键
    goBack() {
      this.detailShow = !this.detailShow;
    },
    // 获取公告列表
    getChatNotice(page) {
      this.axios({
        method: "post",
        url: this.chatUrl + "/api/article/getArticleInfo",
        data: {
          category_id: 8,
          page: page,
          page_num: this.pageNum
        }
      }).then(res => {
        if (res.data.code == 0) {
          console.log(res.data.data);
          this.isLoading = false;
          this.last_page = res.data.data.last_page;
          this.page = res.data.data.current_page;
          this.per_page =
            parseInt(res.data.data.total / res.data.data.per_page) *
              this.pageNum +
            parseInt(res.data.data.total % this.pageNum);
          this.noticelist = res.data.data.data;
          // for (var i = 0; i < this.noticelist.length; i++) {
          // this.noticelist = this.url + this.noticelist[i].cover;
          // }
        } else {
          this.isLoading = false;
        }
      });
    },
    // 分页器
    currentChange(val) {
      if (val == "" || val == 0 || val > this.last_page) {
        this.store.commit("hintMsg", "请输入正确的页数");
        this.store.commit("hintShow", 1500);
      } else {
        this.histNum2 = val;
        this.page = val;
        this.getChatNotice(this.page);
      }
    }
  }
};
</script>

<style scoped>
#webSite {
  width: 100%;
  height: 100%;
  padding-top: 1.125rem /* 18/16 */;
  position: relative;
  box-sizing: border-box;
}
#webSite ul {
  width: 100%;
  height: 40.125rem /* 642/16 */;
  overflow: hidden;
  text-align: center;
}
#webSite ul .noticeList {
  position: relative;
  display: inline-block;
  width: 75.875rem /* 1214/16 */;
  height: 12.125rem /* 194/16 */;
  background-color: #fff;
  margin-top: 1.25rem /* 20/16 */;
  box-sizing: border-box;
  cursor: pointer;
}
#webSite ul .noticeList .noticeCon {
  height: 5.125rem /* 82/16 */;
  padding: 0 2.375rem /* 38/16 */ 2.875rem /* 46/16 */ 1.8125rem /* 29/16 */;
  margin-top: 3.75rem /* 60/16 */;
  box-sizing: border-box;
  text-align: left;
  color: #8a8a8a;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
#webSite ul .noticeList p {
  position: absolute;
  bottom: 0.8125rem /* 13/16 */;
  right: 2.5rem /* 40/16 */;
  box-sizing: border-box;
  font-size: 0.875rem /* 14/16 */;
  color: #333;
}

.fenye {
  position: absolute;
  bottom: 1.25rem /* 20/16 */;
  right: 0;
  text-align: right;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.25rem;
  width: 80rem /* 860/16 */;
  border-radius: 0.875rem /* 14/16 */;
}
.fenye input {
  width: 3rem;
  height: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1rem;
}
.fenye input span {
  display: block;
  font-size: 1.3rem;
  height: 2rem;
  line-height: 2rem;
  margin-left: 1.5rem;
  color: #409eff;
  margin-top: 0.2rem;
  cursor: pointer;
}

.noticeDetail {
  width: 75.875rem /* 1214/16 */;
  height: 44rem /* 704/16 */;
  box-sizing: border-box;
  padding: 1.5625rem /* 25/16 */ 2.5rem /* 40/16 */ 0 1.75rem /* 28/16 */;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
}
.noticeDetail .timeShow {
  height: 3.9375rem /* 63/16 */;
  line-height: 3.9375rem /* 63/16 */;
  border-bottom: 0.0625rem /* 1/16 */ solid #eaeaea;
  color: #333333;
  font-size: 0.875rem /* 14/16 */;
  text-align: left;
}
.noticeDetail .detailCon {
  height:31.25rem /* 500/16 */;
  padding-top: 1.3125rem /* 21/16 */;
  color: #8a8a8a;
  font-size: 0.875rem /* 14/16 */;
  text-align: left;
  overflow: auto;
}
.detailCon::-webkit-scrollbar {
    display: none;  
}
.noticeDetail .detailCon img {
  width: 1.4375rem /* 23/16 */;
  height: 1.4375rem /* 23/16 */;
  position: absolute;
  bottom: 3.125rem /* 50/16 */;
  left: 50%;
  transform: translate(-50%);
}
pre {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/components/chatPlaza/webSite.vue